import type { IContainer } from '../../interface/container';
import { injectFetch, injectZip } from '../../interface/util';
import { injectProgressPromise } from '../../interface/promise';
import { ISiteDataAPI } from '../interface/siteData';
import { injectConfigAPI } from '../../interface/config';
import getSiteData from './siteData';

function siteData(container: IContainer): ISiteDataAPI {
    const promiser = injectProgressPromise(container);
    const fetcher = injectFetch(container);
    const zip = injectZip(container);
    const config = injectConfigAPI(container);

    const module: ISiteDataAPI = {
        getSiteData: (apiURL: string, authToken: string, hash = '', timeout = 20 * 1000) =>
            getSiteData(promiser, fetcher, zip, config, authToken, hash, timeout),
    };

    return module;
}

export default siteData;
